import React from 'react'
import { useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import LinearProgress from '@material-ui/core/LinearProgress'
import classnames from 'classnames'
import PropTypes from 'prop-types'

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    position: 'absolute',
    bottom: -6,
    zIndex: 3000,
  },
  barColor: {
    backgroundColor: '#00a951',
  },
  barColorSecondary: {
    backgroundColor: '#36f4a342',
  },
}))

const Loading = ({ className }) => {
  const loading = useSelector((state) => state.loading > 0)
  const classes = useStyles()
  return (
    <div className={classnames(classes.root, { [className]: className })}>
      {(loading) && (
      <LinearProgress color="primary" />
      )}
    </div>
  )
}

Loading.propTypes = {
  className: PropTypes.string,
}

export default Loading
